import { createErrorResponse, FetchResponse } from '../fetchWrapper';

export async function getHardwareDetailsReport(id: string) {
  return createErrorResponse('Hardware details report is not implemented') as Promise<
    FetchResponse<any>
  >;
}
